import { render, staticRenderFns } from "./ColorInput.vue?vue&type=template&id=b629b0fe"
import script from "./ColorInput.vue?vue&type=script&lang=ts"
export * from "./ColorInput.vue?vue&type=script&lang=ts"
import style0 from "./ColorInput.vue?vue&type=style&index=0&id=b629b0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports